import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { GridColDef } from "@mui/x-data-grid-pro";
import SaveIcon from "@mui/icons-material/Save";
import CommonDataGridTable from "../../../../../CommonDataGridTable/CommonDataGridTable";

import { useSelector } from "react-redux";

import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { useScopes } from "../../../../../STOperationhooks/useScopes";

const RemoveNegativeDefinitionModal = ({ open, onClose }: any) => {
  const {
    selectedRowsForContradictingSTDefinition, // get the selected rows
    definitionModalSourceForContradictingST,
    toggledNegativesForContradictingSTDefinition,
    confirmLoaderForContradictingSTDefinition,
  } = useSelector((state: any) => state.searchTermTab);

  const { removeNegativeSearchTerm } = useScopes();

  // === COLUMNS ===
  const columns: GridColDef[] = [
    {
      field: "search_term",
      headerName: "Search Term",
      flex: 1,
      minWidth: 160,
    },
    {
      field: "search_term_match_type",
      headerName: "Match Type",
      flex: 0.6,
      minWidth: 110,
    },
    {
      field: "adgroup_name",
      headerName: "Adgroup Name",
      flex: 1,
      minWidth: 200,
    },
  ];

  let mergedList = [];

  // === MERGE SELECTED ROWS WITH DEFINITIONS ===
  if (definitionModalSourceForContradictingST === "headerIcon") {
    mergedList = selectedRowsForContradictingSTDefinition.map((row: any) => ({
      id: row.id,
      search_term: row.search_term,
      keyword_name: row.keyword_name,
      keyword_id: row.keyword_id,
      search_term_match_type: row.search_term_match_type,
      campaign_id: row.campaign_id,
      campaign_name: row.campaign_name,
      adgroup_id: row.adgroup_id,
      adgroup_name: row.adgroup_name,
      ad_shared_uid: row.ad_shared_uid,
      search_term_shared_uid: row.search_term_shared_uid,
      neg_search_term_shared_uid: row.neg_search_term_shared_uid,
      no_of_adgroups: 1,
    }));
  } else if (definitionModalSourceForContradictingST === "saveButton") {
    mergedList = toggledNegativesForContradictingSTDefinition.map(
      (row: any) => ({
        id: row.id,
        search_term: row.search_term,
        keyword_name: row.keyword_name,
        keyword_id: row.keyword_id,
        search_term_match_type: row.search_term_match_type,
        campaign_id: row.campaign_id,
        campaign_name: row.campaign_name,
        adgroup_id: row.adgroup_id,
        adgroup_name: row.adgroup_name,
        ad_shared_uid: row.ad_shared_uid,
        search_term_shared_uid: row.search_term_shared_uid,
        neg_search_term_shared_uid: row.neg_search_term_shared_uid,
        no_of_adgroups: 1,
      })
    );
  } else {
    mergedList = [];
  }

  const hasData = mergedList.length > 0;

  const removeNegativeSearchTerms = async () => {
    const sharedUids =
      mergedList?.map((item: any) => item.neg_search_term_shared_uid) || [];
    if (sharedUids.length === 0) return;
    const reqBody = {
      terms: sharedUids.map((uid: string) => ({
        shared_uid: uid,
      })),
    };

    removeNegativeSearchTerm(reqBody, onClose, "ContradictingST");
  };

  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        // Prevent close if loading and the reason is backdrop click or escape key
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        onClose();
      }}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle>
        Total Number of Search Terms Who's Negative Definition Is Removed:{" "}
        {mergedList.length || 0}{" "}
      </DialogTitle>
      <DialogContent
        sx={{
          backgroundColor: "transparent",
        }}
      >
        {hasData ? (
          <>
            <Box sx={{ mt: 2 }}>
              <CommonDataGridTable rows={mergedList} columns={columns} />
            </Box>
          </>
        ) : (
          <Typography
            sx={{ py: 4, textAlign: "center", color: "text.secondary" }}
          >
            No search terms selected.
          </Typography>
        )}
        <Box
          sx={{
            backgroundColor: "#FFF4E5",
            padding: "8px 16px",
            borderRadius: "4px",
            border: "1px solid #ed6c02",
            width: "auto",
            marginTop: 2,
          }}
        >
          <Typography
            align="center"
            color="#ed6c02"
            display="flex"
            alignItems="center"
          >
            <ErrorOutlineOutlinedIcon style={{ marginRight: 5 }} />
            Search Terms Negative Definitions are removed from Adgroup
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ padding: "16px 20px 16px" }}>
        <Button
          disabled={confirmLoaderForContradictingSTDefinition}
          onClick={onClose}
          color="secondary"
          variant="outlined"
        >
          Cancel
        </Button>
        <Button
          data-tracker="561"
          variant="contained"
          onClick={removeNegativeSearchTerms}
          loading={confirmLoaderForContradictingSTDefinition}
          loadingPosition="end"
          endIcon={confirmLoaderForContradictingSTDefinition && <SaveIcon />}
          disabled={
            !mergedList?.length || confirmLoaderForContradictingSTDefinition
          }
          color="secondary"
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RemoveNegativeDefinitionModal;
